/*
 * Katana Cart — quantity + remove via the Cart Change API with Section
 * Rendering, so line prices, totals, and the empty state refresh without a
 * full page reload. Uses event delegation so it survives content swaps.
 */
(function () {
  'use strict';

  function initCart(root) {
    var sectionId = root.getAttribute('data-kcart-section');
    var routeRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    function change(key, quantity) {
      var contents = root.querySelector('[data-kcart-contents]');
      if (contents) contents.classList.add('is-updating');
      fetch(routeRoot + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity, sections: sectionId, sections_url: routeRoot + 'cart' })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var html = cart.sections && cart.sections[sectionId];
          if (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var next = doc.querySelector('[data-kcart-contents]');
            var cur = root.querySelector('[data-kcart-contents]');
            if (next && cur) {
              cur.innerHTML = next.innerHTML;
              cur.classList.remove('is-updating');
              return;
            }
          }
          window.location.reload();
        })
        .catch(function () { window.location.reload(); });
    }

    root.addEventListener('click', function (e) {
      var minus = e.target.closest('[data-kcart-minus]');
      var plus = e.target.closest('[data-kcart-plus]');
      var remove = e.target.closest('[data-kcart-remove]');
      if (!minus && !plus && !remove) return;

      var item = e.target.closest('[data-kcart-item]');
      if (!item) return;
      e.preventDefault();

      var key = item.getAttribute('data-line-key');
      var qty = parseInt(item.getAttribute('data-qty'), 10) || 0;
      var next = remove ? 0 : (minus ? qty - 1 : qty + 1);
      if (next < 0) next = 0;
      change(key, next);
    });
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-kcart]'), initCart);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
